import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import CommonAnimationWrapper from "./CommonAnimationWrapper";
export default function CommonChangeAnimation(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 1,
      transition: {
        opacity: {
          duration: 0.3
        },
        ease: "easeInOut"
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      transition: {
        opacity: {
          duration: 0.3
        },
        ease: "easeInOut"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <CommonAnimationWrapper><motion.div initial={t1} animate={t2} exit={t3}>{children}</motion.div></CommonAnimationWrapper>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}